


























































































import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { SidebarItem } from '@/types'
import {
  COMPANY_FETCH_COMPANY_STRUCTURE,
  FETCH_ADDRESS_GROUP, FETCH_COMMISSION_GROUP, FETCH_PRODUCT_GROUP,
  FETCH_PROJECT_GROUP, FETCH_RECRUITING_GROUP,
  LOAD_APP_MENU,
  SET_SHOW_MENU_ADDRESS,
  SET_SHOW_MENU_DISPOSITION,
  SET_SHOW_MENU_PROJECT,
  SET_UPDATE_MENU
} from '@/store/action-types'
import { SET_COMPANYSTRUTURE_MENU } from '@/store/mutation-types'
import * as appMenuService from '@/services/app-menu-service'
import { MenuFilterScope, MenuDataEnum, SecurityArea, SecurityComponent } from '@/types/enums'
import {
  COMPANY_GET_BASIC_COMPANY_STRUCTURE,
  COMPANY_GET_INITIALIZED_STATE,
  GET_SHOW_MENU_ADDRESS,
  GET_SHOW_MENU_DISPOSITION,
  GET_SHOW_MENU_PROJECT,
  GET_UPDATE_MENU
} from '@/store/getter-types'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import { ProjectGroup } from '@/model/project/ProjectGroup'
import { ProductGroup } from '@/model/products/ProductGroup'
import { ProductGroupResponse } from '@/types/service-response'
import { RecruitingGroup } from '@/model/recruiting/RecruitingGroup'
import { CommissionGroup } from '@/model/commissions/CommissionGroup'
import * as securityService from '@/services/security-service'

interface ComponentData {
  selectedItem: SidebarItem | undefined
  selectedDisplayedItem: SidebarItem | undefined
  companiesLoaded: boolean
  search: string
  searchDisabled: boolean
  displaySearchMenu: boolean
  isFilterActive: boolean
  filterSearchString: string | null
  filterScope: MenuFilterScope
  selectedAddressGroup: SidebarItem | undefined
  selectedProjectGroup: SidebarItem | undefined
}

export default Vue.extend({
  name: 'AppMenu',

  data (): ComponentData {
    return {
      selectedItem: undefined,
      selectedDisplayedItem: undefined,
      companiesLoaded: false,
      search: '',
      searchDisabled: true,
      displaySearchMenu: false,
      isFilterActive: true,
      filterSearchString: '',
      filterScope: MenuFilterScope.Active,
      selectedAddressGroup: undefined,
      selectedProjectGroup: undefined
    }
  },

  computed: {
    ...mapState({
      sidebar: 'sidebar',
      selectedUiLanguage: 'selectedUiLanguage'
    }),

    ...mapGetters([GET_UPDATE_MENU]),
    ...mapGetters([GET_SHOW_MENU_ADDRESS]),
    ...mapGetters([GET_SHOW_MENU_DISPOSITION]),
    ...mapGetters([GET_SHOW_MENU_PROJECT]),

    showSearchBar (): boolean {
      let show = false
      /*if (this.selectedDisplayedItem) {
        show = [
          MenuDataEnum.CompanyDataSettings,
          MenuDataEnum.ProfitCenterSettings,
        ].indexOf(<MenuDataEnum>this.selectedDisplayedItem.category!) !== -1

        if(this.selectedDisplayedItem.category === MenuDataEnum.Department && this.selectedDisplayedItem.route && this.selectedDisplayedItem.route.includes('settings')) {
          show = true
        }
      }*/
      return show
    },

    showEmployeeSearch (): boolean {
      let show = false
      if (this.selectedDisplayedItem) {
        show = [
          MenuDataEnum.CompanyData,
          MenuDataEnum.ProfitCenter,
          MenuDataEnum.Department,
          MenuDataEnum.Employee
        ].indexOf(<MenuDataEnum>this.selectedDisplayedItem.category!) !== -1

        if(this.selectedDisplayedItem.category === MenuDataEnum.Department && this.selectedDisplayedItem.route && this.selectedDisplayedItem.route.includes('settings')) {
          show = false
        }
      }
      return show
    },

    showEmployeeInsert (): boolean {
      let show = false
      if (this.selectedDisplayedItem && !this.$store.state.currentUser.lohnIntegration && securityService.isVisible(SecurityArea.Employee, SecurityComponent.EmployeeIconInsert)) {
        show = [
          MenuDataEnum.CompanyData,
          MenuDataEnum.ProfitCenter,
          MenuDataEnum.Department,
          MenuDataEnum.Employee
        ].indexOf(<MenuDataEnum>this.selectedDisplayedItem.category!) !== -1

        if(this.selectedDisplayedItem.category === MenuDataEnum.Department && this.selectedDisplayedItem.route && this.selectedDisplayedItem.route.includes('settings')) {
          show = false
        }
      }
      return show
    },

    isEmployeeInsertDisabled (): boolean {
      return securityService.isDisabled(SecurityArea.Employee, SecurityComponent.EmployeeIconInsert)
    },

    showRecruitingSearch (): boolean {
      let show = false
      if (this.selectedDisplayedItem) {
        show = [
          MenuDataEnum.RecruitingGroup,
          MenuDataEnum.RecruitingGroupItem,
        ].indexOf(<MenuDataEnum>this.selectedDisplayedItem.category!) !== -1
      }
      return show
    },

    showAddressSearch (): boolean {
      let show = false
      if (this.selectedDisplayedItem) {
        show = [
          MenuDataEnum.AddressGroup,
          MenuDataEnum.AddressGroupItem,
        ].indexOf(<MenuDataEnum>this.selectedDisplayedItem.category!) !== -1
      }
      return show
    },

    showCommissionsSearch (): boolean {
      let show = false
      if (this.selectedDisplayedItem) {
        show = [
          MenuDataEnum.CommissionGroup,
          MenuDataEnum.CommissionGroupItem,
        ].indexOf(<MenuDataEnum>this.selectedDisplayedItem.category!) !== -1
      }
      return show
    },

    showProductSearch (): boolean {
      let show = false
      if (this.selectedDisplayedItem) {
        show = [
          MenuDataEnum.ProductGroup,
          MenuDataEnum.ProductGroupItem,
        ].indexOf(<MenuDataEnum>this.selectedDisplayedItem.category!) !== -1
      }
      return show
    },

    showProjectSearch (): boolean {
      let show = false
      if (this.selectedDisplayedItem) {
        show = [
          MenuDataEnum.ProjectGroup,
          MenuDataEnum.ProjectGroupItem
        ].indexOf(<MenuDataEnum>this.selectedDisplayedItem.category!) !== -1
      }
      return show
    },

    currentItems (): Array<SidebarItem> {
      if (this.selectedItem && this.selectedItem.children && this.selectedItem.children.length > 0) {
        if (this.selectedItem.category === MenuDataEnum.Department) {
          if(this.filterScope === MenuFilterScope.Active) {
            return this.selectedItem.children.filter((item: SidebarItem) => item.active)
          } else if(this.filterScope === MenuFilterScope.Passive) {
            return this.selectedItem.children.filter((item: SidebarItem) => !item.active)
          } else {
            return this.selectedItem.children
          }
        } else {
          if (this.selectedItem.category === MenuDataEnum.PlanningData) {
            const settings = this.$store.state.settings
            if (settings.industrialTimeModel === 0 && settings.simpleWeekTimeModel === 1) {
              return this.selectedItem.children.filter((item: SidebarItem) => item.category === MenuDataEnum.Simple)
            } else if (settings.industrialTimeModel === 1 && settings.simpleWeekTimeModel === 0) {
              return this.selectedItem.children.filter((item: SidebarItem) => item.category === MenuDataEnum.Industrial)
            } else {
              return this.selectedItem.children.filter((item: SidebarItem) => item.category === MenuDataEnum.Simple)
            }
          } else {
            return this.selectedItem.children
          }
        }
      } else if (this.$store.state.sidebar) {
        return this.$store.state.sidebar.children
      } else {
        return []
      }
    },

    currentSelectedItemText (): string {
      return this.selectedDisplayedItem ? (this.selectedDisplayedItem.text ? this.selectedDisplayedItem.text : 'Menu') : 'Menu'
    },

    filterIconColor (): string {
      return this.isFilterActive ? 'primary' : 'secondary'
    },

    getSearchMenuLeft (): number {
      if(this.$vuetify.breakpoint.xsOnly) {
        return -3
      } else {
        return -236
      }
    }
  },

  methods: {
    onAddEmployeeClick (): void {
      this.$router.push({ path: '/employee-detail', query: { create: 'true' }})
    },

    onAddressClick (): void {
      this.$router.push('/address')
    },

    onAddAddressClick (): void {
      this.$router.push({ path: '/address', query: { create: 'true' }})
    },

    onCommissionClick (): void {
      this.$router.push('/commissions')
    },

    onAddCommissionClick (): void {
      this.$router.push({ path: '/commissions', query: { create: 'true' }})
    },

    onProductClick (): void {
      this.$router.push('/product')
    },

    onAddProductClick (): void {
      this.$router.push({ path: '/product', query: { create: 'true' }})
    },

    onProjectClick (): void {
      this.$router.push('/project')
    },

    onAddProjectClick (): void {
      this.$router.push({ path: '/project', query: { create: 'true' }})
    },

    getIconColor (item: SidebarItem): string {
      if (item.category === MenuDataEnum.Employee) {
        return item.active ? 'primary' : 'secondary'
      } else {
        return 'primary'
      }
    },

    onMenuItemClick (item: SidebarItem): void {
      this.selectedDisplayedItem = item
      if (item.children === undefined || (item.children && item.children.length === 0)) {
        if (item.category === MenuDataEnum.CompanyData || item.category === MenuDataEnum.CompanyDataSettings || item.category === MenuDataEnum.ProfitCenterSettingsWithDepartment
          || item.category === MenuDataEnum.EmployeeHierarchySettings || item.category === MenuDataEnum.ProfitCenterAdditionalFieldsSettings) {
          this.fetchCompanyStructureData(item)
        } else if(item.category === MenuDataEnum.AddressGroup) {
          this.fetchAddress(item)
        } else if(item.category === MenuDataEnum.CommissionGroup) {
          this.fetchCommissions(item)
        } else if(item.category === MenuDataEnum.ProductGroup) {
          this.fetchProduct(item)
        } else if(item.category === MenuDataEnum.ProjectGroup) {
          this.fetchProject(item)
        } else if(item.category === MenuDataEnum.RecruitingGroup) {
          this.fetchRecruiting(item)
        }
      } else {
        if (item.category === MenuDataEnum.CompanyData || item.category === MenuDataEnum.ProfitCenterSettingsWithDepartment
          || item.category === MenuDataEnum.EmployeeHierarchySettings || item.category === MenuDataEnum.ProfitCenterAdditionalFieldsSettings) {
          this.selectedItem = item
        } else {
          this.selectedItem = item
        }
      }
    },

    async fetchCompanyStructureData (item: SidebarItem): Promise<void> {
      const initialized = this.$store.getters[COMPANY_GET_INITIALIZED_STATE]
      !initialized && await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
      const data = this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]
      const list: Array<SidebarItem> = appMenuService.createSidebarFromResponse(data, item.category)
      this.$store.commit(SET_COMPANYSTRUTURE_MENU, { list: list, menuItemToInsert: item })
      this.selectedItem = item
      this.searchDisabled = false
      // @ts-ignore
      //this.$refs.searchInput && this.$nextTick(this.$refs.searchInput.focus)
    },

    async fetchAddress(item:SidebarItem): Promise<void> {
      if(item.category === MenuDataEnum.AddressGroup) {
        const addressGroupData: Array<AddressGroup> = await this.$store.dispatch(FETCH_ADDRESS_GROUP)
        const list: Array<SidebarItem> = appMenuService.createAddressSidebarItem(addressGroupData, MenuDataEnum.AddressGroupItem)
        this.$store.commit(SET_COMPANYSTRUTURE_MENU, { list: list, menuItemToInsert: item })
        this.selectedItem = item
        this.searchDisabled = false
      }
    },

    async fetchCommissions(item:SidebarItem): Promise<void> {
      if(item.category === MenuDataEnum.CommissionGroup) {
        const commissionGroupData: CommissionGroup[] = await this.$store.dispatch(FETCH_COMMISSION_GROUP)
        const list: Array<SidebarItem> = appMenuService.createCommissionsSidebarItem(commissionGroupData, MenuDataEnum.CommissionGroupItem)
        this.$store.commit(SET_COMPANYSTRUTURE_MENU, { list: list, menuItemToInsert: item })
        this.selectedItem = item
        this.searchDisabled = false
      }
    },

    async fetchProduct(item:SidebarItem): Promise<void> {
      if(item.category === MenuDataEnum.ProductGroup) {
        try {
          const response: ProductGroupResponse = await this.$store.dispatch(FETCH_PRODUCT_GROUP)
          if(!response.IsError && response.Data) {
            const productGroupData: ProductGroup[] = ProductGroup.createFromResponse(response.Data)
            const list: Array<SidebarItem> = appMenuService.createProductSidebarItem(productGroupData, MenuDataEnum.ProductGroupItem)
            this.$store.commit(SET_COMPANYSTRUTURE_MENU, { list: list, menuItemToInsert: item })
            this.selectedItem = item
            this.searchDisabled = false
          } else {}
        } catch {}
      }
    },

    async fetchProject (item: SidebarItem): Promise<void> {
      if(item.category === MenuDataEnum.ProjectGroup) {
        const projectGroupData: Array<ProjectGroup> = await this.$store.dispatch(FETCH_PROJECT_GROUP)
        const list: Array<SidebarItem> = appMenuService.createProjectSidebarItem(projectGroupData, MenuDataEnum.ProjectGroupItem)
        this.$store.commit(SET_COMPANYSTRUTURE_MENU, { list: list, menuItemToInsert: item })
        this.selectedItem = item
        this.searchDisabled = false
      }
    },

    async fetchRecruiting (item: SidebarItem): Promise<void> {
      if(item.category === MenuDataEnum.RecruitingGroup) {
        const recruitingGroupData: Array<RecruitingGroup> = await this.$store.dispatch(FETCH_RECRUITING_GROUP)
        const list: Array<SidebarItem> = appMenuService.createRecruitingSidebarItem(recruitingGroupData, MenuDataEnum.RecruitingGroupItem)
        this.$store.commit(SET_COMPANYSTRUTURE_MENU, { list: list, menuItemToInsert: item })
        this.selectedItem = item
        this.searchDisabled = false
      }
    },

    showNextIcon (item: SidebarItem): boolean {
      return (item.children && item.children.length > 0) || (item.config && item.config.showIcon)
    },

    onBackButtonClick (): void {
      let result: SidebarItem | undefined = undefined
      let parent2: SidebarItem | undefined
      if(this.selectedItem && (this.selectedItem.category === MenuDataEnum.CompanyData || this.selectedItem.category === MenuDataEnum.AddressGroup || this.selectedItem.category === MenuDataEnum.CommissionGroup || this.selectedItem.category === MenuDataEnum.ProductGroup || this.selectedItem.category === MenuDataEnum.ProjectGroup || this.selectedItem.category === MenuDataEnum.RecruitingGroup)) {
        this.filterSearchString = ''
        this.filterScope = MenuFilterScope.Active
      }
      this.displaySearchMenu = false
      let selectedItem: SidebarItem
      if (this.selectedItem === undefined) {
        this.selectedDisplayedItem = undefined
        this.selectedItem = undefined
        return
      } else {
        selectedItem = this.selectedItem
      }

      const checkTreeElement = function (treeItem: SidebarItem): void {
        if (result === undefined) {
          parent2 = treeItem
          if (treeItem.children && treeItem.children.length > 0) {
            let check = treeItem.children.find((item: SidebarItem): boolean => item === selectedItem)
            result = check ? parent2 : undefined
          }
        }

        if (treeItem.children && treeItem.children.length > 0) {
          treeItem.children.forEach((item: SidebarItem) => checkTreeElement(item))
        }
      }

      checkTreeElement(this.$store.state.sidebar)

      if (result !== undefined) {
        this.selectedDisplayedItem = result
        this.selectedItem = result
      } else {
        this.selectedDisplayedItem = undefined
        this.selectedItem = undefined
      }
    },

    displayBadge (sidebarItem: SidebarItem): string {
      return (sidebarItem && sidebarItem.config && sidebarItem.config.badge !== 0) ? sidebarItem.config.badge : ''
    },

    filterEmployeeListByScope (employeeList: SidebarItem[]): SidebarItem[] {
      if(this.filterScope === MenuFilterScope.Active) {
        return employeeList.filter((item: SidebarItem) => item.active)
      } else if(this.filterScope === MenuFilterScope.Passive) {
        return employeeList.filter((item: SidebarItem) => !item.active)
      } else {
        return employeeList
      }
    },

    showBadge (sidebarItem: SidebarItem): boolean {
      let counter = 0
      if (this.search !== '') {
        if (sidebarItem && sidebarItem.category === MenuDataEnum.ProfitCenter) {
          // @ts-ignore
          sidebarItem.children.forEach((department: SidebarItem) => {
            if (department && department.children) {

              let employeeList: SidebarItem[] = this.filterEmployeeListByScope(department.children)

              // @ts-ignore
              counter += employeeList.filter((employee: SidebarItem) => {
                return employee.category === MenuDataEnum.Employee && employee.text.toLowerCase().includes(this.search.toLowerCase())
              }).length
            }
          })
          sidebarItem.config.badge = counter
        }
        if (sidebarItem && sidebarItem.category === MenuDataEnum.Department) {
          if (sidebarItem.children) {
            let employeeList: SidebarItem[] = this.filterEmployeeListByScope(sidebarItem.children)

            // @ts-ignore
            counter += employeeList.filter((employee: SidebarItem) => {
              return employee.category === MenuDataEnum.Employee && employee.text.toLowerCase().includes(this.search.toLowerCase())
            }).length
          }
          sidebarItem.config.badge = counter
        }
        if (sidebarItem && sidebarItem.category === MenuDataEnum.RecruitingGroupItem) {
          if (sidebarItem.config.data) {

            counter += sidebarItem.config.data.filter((item: any) => {
              const fullName: string = `${item.name}${item.vorname}`
              return fullName.toLowerCase().includes(this.search.replace(' ', '').toLowerCase())
            }).length
          }
          sidebarItem.config.badge = counter
        }
      }
      return counter !== 0
    },

    filter (sidebarItem: SidebarItem): boolean {
      if (this.search === '') {
        return true
      }
      if (sidebarItem.category === MenuDataEnum.Employee && sidebarItem.text.toLowerCase().includes(this.search.toLowerCase())) {
        return true
      }
      return false
    },

    changeLanguage (item: SidebarItem) {
      if(item.children) {
        item.children.forEach((i: SidebarItem) => {
          if (this.selectedDisplayedItem && i.id === this.selectedDisplayedItem.id) {
            this.onMenuItemClick(i)
          } else {
            this.changeLanguage(i)
          }
        })
      }
    }
  },

  watch: {
    selectedDisplayedItem (newValue: SidebarItem): void {
      if (newValue) {
        // clear search-bar when back button clicked on company level
        if (newValue.category !== MenuDataEnum.PlanningData &&
          newValue.category !== MenuDataEnum.CompanyData &&
          newValue.category !== MenuDataEnum.ProfitCenter &&
          newValue.category !== MenuDataEnum.ProfitCenterSettings &&
          newValue.category !== MenuDataEnum.CompanyDataSettings &&
          newValue.category !== MenuDataEnum.Department &&
          newValue.category !== MenuDataEnum.Employee &&
          newValue.category !== MenuDataEnum.AddressGroup &&
          newValue.category !== MenuDataEnum.AddressGroupItem &&
          newValue.category !== MenuDataEnum.CommissionGroup &&
          newValue.category !== MenuDataEnum.CommissionGroupItem &&
          newValue.category !== MenuDataEnum.ProductGroup &&
          newValue.category !== MenuDataEnum.ProductGroupItem &&
          newValue.category !== MenuDataEnum.ProjectGroup &&
          newValue.category !== MenuDataEnum.ProjectGroupItem &&
          newValue.category !== MenuDataEnum.RecruitingGroup &&
          newValue.category !== MenuDataEnum.RecruitingGroupItem) {
          this.search = ''
          this.filterSearchString = ''
        }

        if(newValue.category === MenuDataEnum.RecruitingGroup && !this.search) {
          if(this.selectedItem && this.selectedItem.children && this.selectedItem.category === MenuDataEnum.RecruitingGroup) {
            this.selectedItem.children.forEach((item: SidebarItem) => {
              item.route = item.config.route
            })
          }
        }
      }
    },

    selectedUiLanguage (newVal) {
      if (newVal.syzId) {
        this.$store.dispatch(LOAD_APP_MENU)
        this.selectedItem = undefined
        this.selectedDisplayedItem = undefined
        this.companiesLoaded = false
        this.search = ''
        this.filterSearchString = ''
        this.searchDisabled = true
      }
    },

    filterSearchString (newVal: string): void {
      if(newVal) {
        this.search = newVal
        if(this.selectedItem && this.selectedItem.children && this.selectedItem.category === MenuDataEnum.RecruitingGroup) {
          this.selectedItem.children.forEach((item: SidebarItem) => {
            item.route = `${item.config.route}/${this.search.replace(' ', '').toLowerCase()}`
          })
        }

        this.isFilterActive = true
      } else {
        this.search = ''
        if(this.selectedItem && this.selectedItem.children && this.selectedItem.category === MenuDataEnum.RecruitingGroup) {
          this.selectedItem.children.forEach((item: SidebarItem) => {
            item.route = item.config.route
          })
        }

        if(this.filterScope === MenuFilterScope.All) {
          this.isFilterActive = false
        }
      }
    },

    filterScope (newVal: MenuFilterScope): void {
      if(newVal === MenuFilterScope.All && !this.search) {
        this.isFilterActive = false
      } else {
        this.isFilterActive = true
      }
    },

    [GET_UPDATE_MENU] (newVal: boolean): void {
      if (newVal) {
        this.onBackButtonClick()
        this.$store.dispatch(SET_UPDATE_MENU, false)
      }
    },

    [GET_SHOW_MENU_ADDRESS] (newVal: boolean): void {
      if(newVal) {
        this.$store.dispatch(SET_SHOW_MENU_ADDRESS, false)
        const foundItem: SidebarItem | undefined = this.$store.state.sidebar.children.find((item: SidebarItem) => item.id === "esoft2")
        if(foundItem) {
          const addressItem: SidebarItem | undefined = foundItem.children!.find((item: SidebarItem) => item.category === MenuDataEnum.AddressGroup)
          if(addressItem) {
            this.onMenuItemClick(addressItem)
          }
        }
      }
    },

    [GET_SHOW_MENU_PROJECT] (newVal: boolean): void {
      if(newVal) {
        this.$store.dispatch(SET_SHOW_MENU_PROJECT, false)
        const foundItem: SidebarItem | undefined = this.$store.state.sidebar.children.find((item: SidebarItem) => item.id === "esoft8")
        if(foundItem) {
          this.onMenuItemClick(foundItem)
        }
      }
    },

    [GET_SHOW_MENU_DISPOSITION] (newVal: boolean): void {
      if(newVal) {
        this.$store.dispatch(SET_SHOW_MENU_DISPOSITION, false)
        const foundItem: SidebarItem | undefined = this.$store.state.sidebar.children.find((item: SidebarItem) => item.id === "esoft7")
        if(foundItem) {
          this.onMenuItemClick(foundItem)
        }
      }
    }

  },

  mounted () {
    this.$store.dispatch(LOAD_APP_MENU)
  }
})
